import {useRelayEnvironment} from 'react-relay'


const useAtmosphere = () => {
  return useRelayEnvironment() 
}

export default useAtmosphere
